// import Footer from 'components/Footer'
// import React, { useEffect } from 'react'
// import Header from './Home1/Header'

// const PrivPolicy = () => {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//       }, []);
//   return (
//     <>    
//     {/* <Header/> */}
//     <div style={{width:'100%'}} >

//         <div className="bannerImage" style={{width:'100%',height:'400px',display:'flex',alignItems:'center',justifyContent:'center',background:'#747EEF'}}>
//             <h1 style={{textAlign:'center',fontSize:'50px',color:'white',fontFamily:'General Sans !important'}}>Privacy Policy</h1>
//         </div>
//      <div style={{width:'85%',margin:'auto',fontFamily:'General Sans !important'}}>
//     <h3 style={{marginTop:'50px',fontFamily:'General Sans !important',fontSize:30}}><strong>Privacy Policy</strong></h3>
//     <p style={{textAlign:'justify',marginTop:'30px',fontFamily:'General Sans !important'}}>This privacy policy applies to the Washta app (hereby referred to as "Application") for mobile devices that was created by Muhammad Raheel (hereby referred to as "Service Provider") as a Free service. This service is intended for use "AS IS".</p>
    
//     <h3 style={{marginTop:'20px',fontFamily:'General Sans !important'}}>Information Collection and Use</h3>
//     <p>
//     <p style={{marginTop:'20px',fontSize:'15px',fontFamily:'General Sans !important'}}>The Application collects information when you download and use it. This information may include information such as</p>
//   <ul style={{paddingLeft:'40px', paddingTop:'20px'}}>
//     <li style={{fontFamily:'General Sans !important'}}>Your device's Internet Protocol address (e.g. IP address)</li>
//     <li style={{fontFamily:'General Sans !important'}}>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
//     <li style={{fontFamily:'General Sans !important'}}> The time spent on the Application</li>
//     <li style={{fontFamily:'General Sans !important'}}>The operating system you use on your mobile device</li>
// </ul>

    
    
    
//    <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}> The Application collects your device's location, which helps the Service Provider determine your approximate geographical location and make use of in below ways:</p>
//    <ul style={{paddingLeft:'40px',paddingTop:'20px',fontFamily:'General Sans !important'}}>
//         <li style={{fontFamily:'General Sans !important'}}>Geolocation Services: The Service Provider utilizes location data to provide features such as personalized content, relevant recommendations, and location-based services.</li>
//         <li style={{fontFamily:'General Sans !important'}}> Analytics and Improvements: Aggregated and anonymized location data helps the Service Provider to analyze user behavior, identify trends, and improve the overall performance and functionality of the Application.</li>
//         <li style={{fontFamily:'General Sans !important'}}> Third-Party Services: Periodically, the Service Provider may transmit anonymized location data to external services. These services assist them in enhancing the Application and optimizing their offerings.</li>
        
//    </ul>

    
   
   
    
//    <p style={{paddingTop:'20px'}}> The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.</p>
    
//    <p style={{paddingTop:'20px'}}> For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information, including but not limited to male. The information that the Service Provider request will be retained by them and used as described in this privacy policy.</p>
    
//     <h3 style={{paddingTop:'20px'}}>Third Party Access</h3>
//    <p style={{paddingTop:'20px'}}> Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.</p>
    
//    <p style={{paddingTop:'20px'}}> Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:</p>
//    <ul style={{paddingLeft:'40px',paddingTop:'20px'}}>
//         <li><a href='#' style={{fontFamily:'General Sans !important'}}>Google Play Service</a></li>
//         <li><a href='#' style={{fontFamily:'General Sans !important'}}>Google Analytics for Firebase</a></li>
//         <li><a href='#' style={{fontFamily:'General Sans !important'}}>Firebase Crashlytics</a></li>
//         <li><a href='#' style={{fontFamily:'General Sans !important'}}>Facebook</a></li>
//    </ul>
    
    
    
    
    
//     <p style={{paddingTop:'20px'}}>The Service Provider may disclose User Provided and Automatically Collected Information:</p>
//     <ul style={{paddingLeft:'40px', paddingTop:'20px'}}>
//         <li style={{fontFamily:'General Sans !important'}}> as required by law, such as to comply with a subpoena, or similar legal process;</li>
//         <li style={{fontFamily:'General Sans !important'}}>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;</li>
//         <li style={{fontFamily:'General Sans !important'}}> with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.</li>    
//     </ul>
    
    
   
    
//     <h3 style={{paddingTop:'20px' ,fontFamily:'General Sans !important'}}>Opt-Out Rights</h3>
//     <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.</p>
    
//     <h3 style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>Data Retention Policy</h3>
//     <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}> The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at bigwalstudio@gmail.com and they will respond in a reasonable time.
//     </p>
//     <h3 style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>Children</h3>
//     <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.</p>

//    <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}> The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (bigwalstudio@gmail.com) so that they will be able to take the necessary actions.
//     </p>
//     <h3 style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>Security</h3>
//     <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
//     </p>
//     <h3 style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>Changes</h3>
//     <p style={{paddingTop:'20px', fontFamily:'General Sans !important'}}>This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
//     </p>
//     <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>This privacy policy is effective as of 2024-06-10
//     </p>
//     <h3 style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>Your Consent</h3>
//     <p style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
//     </p>
//     <h3 style={{paddingTop:'20px',fontFamily:'General Sans !important'}}>Contact Us</h3>
//     <p style={{paddingTop:'20px',fontFamily:'General Sans !important',fontFamily:'General Sans !important', paddingBottom:'70px'}}>If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at <a href='https://www.bigwals.com'>info@washta.com    </a></p>
//     </p>
//     </div>
//     <Footer/>
//     </div>
//     </>

//   )
  
// }

// export default PrivPolicy
import Footer from 'components/Footer'
import React, { useEffect } from 'react'

const PrivPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Font Styles
    const headingFont = "'General Sans', sans-serif";
    const bodyFont = "'Manrope', sans-serif";

    const sectionTitleStyle = {
        marginTop: '40px',
        marginBottom: '15px',
        fontFamily: headingFont,
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333',
        textTransform: 'uppercase'
    };

    const subSectionTitleStyle = {
        marginTop: '25px',
        marginBottom: '10px',
        fontFamily: headingFont,
        fontSize: '20px',
        fontWeight: '600',
        color: '#444'
    };

    const paragraphStyle = {
        textAlign: 'justify',
        marginTop: '10px',
        fontFamily: bodyFont,
        lineHeight: '1.8',
        color: '#555',
        fontSize: '16px'
    };

    const listStyle = {
        paddingLeft: '25px',
        paddingTop: '10px',
        fontFamily: bodyFont,
        color: '#555',
        lineHeight: '1.8',
        fontSize: '16px',
        listStyleType: 'disc'
    };

    return (
        <>
            <div style={{ width: '100%' }}>
                {/* Banner Section */}
                <div className="bannerImage" style={{ width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#747EEF' }}>
                    <h1 style={{ textAlign: 'center', fontSize: '50px', color: 'white', fontFamily: headingFont }}>Privacy Policy</h1>
                </div>

                <div style={{ width: '85%', margin: 'auto', paddingBottom: '100px' }}>
                    <h2 style={{ marginTop: '50px', fontFamily: headingFont, fontSize: '36px' }}><strong>WASHTA PRIVACY POLICY</strong></h2>
                    <p style={paragraphStyle}>
                        <strong>Effective Date:</strong> March 17, 2026 | <strong>Last Updated:</strong> March 17, 2026 
                    </p>

                    {/* 1. DATA CONTROLLER INFORMATION */}
                    <h3 style={sectionTitleStyle}>1. DATA CONTROLLER INFORMATION</h3>
                    <p style={paragraphStyle}>
                        This Privacy Policy describes how Washta collects, uses, shares, and protects your personal data in compliance with the UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (the "UAE PDPL").
                    </p>
                    <ul style={listStyle}>
                        <li>Legal Entity: SNR LLC</li>
                        <li>Commercial Registration: 2429317.01</li>
                        <li>Registered Address: Sharjah Media City, Sharjah, UAE</li>
                        <li>Contact Email: info@washta.com</li>
                        <li>Data Protection Officer: info@washta.com</li>
                    </ul>
                    <p style={paragraphStyle}>The "Platform" refers to the Washta mobile application, website, and all related services provided by Washta.</p>

                    {/* 2. SCOPE AND ACCEPTANCE */}
                    <h3 style={sectionTitleStyle}>2. SCOPE AND ACCEPTANCE</h3>
                    <p style={paragraphStyle}>This Privacy Policy applies to all users of the Washta Platform, including Customers who book services through the Platform and Visitors who browse the Platform without booking services.</p>
                    <p style={paragraphStyle}>By accessing or using the Platform, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy. If you do not agree, please discontinue use of the Platform immediately.</p>

                    {/* 3. INFORMATION WE COLLECT */}
                    <h3 style={sectionTitleStyle}>3. INFORMATION WE COLLECT</h3>
                    <p style={paragraphStyle}>We collect personal data necessary to provide our services. The categories of data we collect include:</p>
                    
                    <h4 style={subSectionTitleStyle}>3.1 Information You Provide Directly</h4>
                    <ul style={listStyle}>
                        <li><strong>Account Registration and Booking Information:</strong> Full name, Phone number, Email address, Vehicle information (plate number, make, model, color), and Service location address.</li>
                        <li><strong>Communications:</strong> Messages, feedback, or inquiries you send to us or Service Providers, and customer service interactions.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>3.2 Information Collected Automatically</h4>
                    <ul style={listStyle}>
                        <li><strong>Device and Technical Information:</strong> IP address, device identifiers, browser type, operating system, and time zone settings.</li>
                        <li><strong>Location Data:</strong> With your explicit consent, we collect precise location data (GPS coordinates) when you search for nearby providers or enter a service location.</li>
                        <li><strong>Usage and Analytics Data:</strong> Pages viewed, navigation patterns, search queries, and error logs.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>3.3 Transaction and Booking Data</h4>
                    <ul style={listStyle}>
                        <li>Booking history, service completion status, and ratings/reviews.</li>
                        <li>Payment transaction confirmations and invoice data.</li>
                    </ul>
                    <p style={{...paragraphStyle, fontWeight: 'bold', color: '#333'}}>
                        Important: Washta does NOT store full credit/debit card numbers, CVV codes, or complete payment card details. All processing is handled by certified third-party processors in compliance with PCI DSS standards.
                    </p>

                    {/* 4. LEGAL BASIS */}
                    <h3 style={sectionTitleStyle}>4. LEGAL BASIS FOR PROCESSING</h3>
                    <p style={paragraphStyle}>Under the UAE PDPL, we process data based on: Contract Performance, Consent (for marketing/location), Legitimate Interest (security/analytics), and Legal Obligation (tax/accounting).</p>

                    {/* 5. HOW WE USE YOUR INFORMATION */}
                    <h3 style={sectionTitleStyle}>5. HOW WE USE YOUR INFORMATION</h3>
                    <ul style={listStyle}>
                        <li><strong>Service Delivery:</strong> Manage bookings and connect you with Service Providers.</li>
                        <li><strong>Payment Processing:</strong> Process payments and detect fraud.</li>
                        <li><strong>Platform Improvement:</strong> Analyze usage patterns to optimize algorithms and user experience.</li>
                        <li><strong>Customer Support:</strong> Respond to inquiries and resolve disputes.</li>
                        <li><strong>Security:</strong> Monitor for security threats and unauthorized access.</li>
                    </ul>

                    {/* 6. DATA SHARING */}
                    <h3 style={sectionTitleStyle}>6. DATA SHARING AND DISCLOSURE</h3>
                    <h4 style={subSectionTitleStyle}>6.1 Service Providers (Independent Businesses)</h4>
                    <p style={paragraphStyle}>Washta operates as an aggregator. When you book, we share booking-related info (name, phone, location, vehicle details) with the selected Provider. They act as independent data controllers.</p>
                    <p style={paragraphStyle}><strong>We do NOT share:</strong> your email address, payment card details, or full booking history with Service Providers.</p>

                    <h4 style={subSectionTitleStyle}>6.2 Payment Processors</h4>
                    <p style={paragraphStyle}>We use Stripe to handle payment transactions. They receive payment card info and transaction amount directly.</p>

                    {/* 7. INTERNATIONAL DATA TRANSFERS */}
                    <h3 style={sectionTitleStyle}>7. INTERNATIONAL DATA TRANSFERS</h3>
                    <p style={paragraphStyle}>Your data may be stored outside the UAE (e.g., EU, USA). We ensure protection through Standard Contractual Clauses and ISO 27001/SOC 2 certified providers.</p>

                    {/* 8. COOKIES */}
                    <h3 style={sectionTitleStyle}>8. COOKIES AND TRACKING</h3>
                    <p style={paragraphStyle}>We use strictly necessary, performance, functionality, and targeting cookies. You can manage preferences through our cookie banner or browser settings.</p>

                    {/* 9. DATA SECURITY */}
                    <h3 style={sectionTitleStyle}>9. DATA SECURITY</h3>
                    <p style={paragraphStyle}>We implement TLS/SSL encryption and secure hosting. In the event of a breach posing a risk to your rights, we will notify the UAE Data Office within 72 hours.</p>

                    {/* 10. DATA RETENTION */}
                    <h3 style={sectionTitleStyle}>10. DATA RETENTION</h3>
                    <ul style={listStyle}>
                        <li><strong>Active account data:</strong> Duration of account + 3 years.</li>
                        <li><strong>Booking & Transaction records:</strong> 7 years (for UAE tax laws).</li>
                        <li><strong>Security logs:</strong> 6 years.</li>
                    </ul>

                    {/* 11. YOUR RIGHTS UNDER UAE PDPL */}
                    <h3 style={sectionTitleStyle}>11. YOUR RIGHTS UNDER UAE PDPL</h3>
                    <p style={paragraphStyle}>You have the following rights: Right of Access, Rectification, Erasure ("Right to be Forgotten"), Restrict Processing, Data Portability, Object to direct marketing, and Withdraw Consent.</p>
                    <p style={paragraphStyle}>To exercise these rights, email: <strong>info@washta.com</strong>. We will respond within 30 days.</p>

                    {/* 13. CHILDREN'S PRIVACY */}
                    <h3 style={sectionTitleStyle}>13. CHILDREN'S PRIVACY</h3>
                    <p style={paragraphStyle}>The Washta Platform is intended for users aged 18 years and older. We do not knowingly collect personal data from individuals under 18.</p>

                    {/* 15. CONTACT INFORMATION */}
                    <h3 style={sectionTitleStyle}>15. CONTACT INFORMATION</h3>
                    <p style={paragraphStyle}>
                        <strong>Washta Data Protection Team</strong> <br />
                        Email: info@washta.com <br />
                        Data Protection Officer: info@washta.com <br />
                        General Inquiries: info@washta.com
                    </p>

                    <div style={{ textAlign: 'center', marginTop: '60px', borderTop: '1px solid #ddd', paddingTop: '30px' }}>
                        <p style={{ ...paragraphStyle, textAlign: 'center', fontWeight: 'bold' }}>
                            Thank you for trusting Washta with your personal information. We are committed to protecting your privacy and using your data responsibly.
                        </p>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default PrivPolicy;